
export class LoadAccountTypesFromApi {
    public static readonly type: string = '[Accounts API] Load account types';
}
